module.exports = __webpack_public_path__ + "static/media/warnning.710c200a.svg";